<template>
    <div class="modal fade show" style="display: block">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header d-none d-sm-block border-0">
                    <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        @click="$emit('close')"
                    >
                        &times;
                    </button>
                </div>
                <div class="modal-body p-0">
                    <div class="d-flex flex-column align-items-center">
                        <div class="title">Delete Task</div>

                        <div class="desc mt-4">
                            Are you sure you want to delete this under task?
                        </div>
                    </div>
                </div>
                <div class="modal-button row">
                    <button
                        class="btn btn-remove col-6"
                        @click="$emit('close')"
                    >
                        Cancel
                    </button>
                    <button
                        class="btn btn-cancel col-6"
                        @click="clickDelete()"
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        clickDelete() {
            this.$emit("clickDelete");
            this.$emit("close");
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-content {
    position: relative;
    .close {
        position: absolute;
        top: 0;
        right: 0;
        background: linear-gradient(135deg, #000000 0%, #28282e 100%);
        border-radius: 100%;
        height: 40px;
        width: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0;
        opacity: 1;
        color: white;
    }

    .title {
        color: #222227;
        font-family: Lato;
        font-size: 28px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 60px;
        text-align: center;
    }

    .desc {
        color: #808fa4;
        font-family: "Open Sans";
        font-size: 16px;
        letter-spacing: 0;
        line-height: 20px;
        text-align: center;
    }

    .btn-remove {
        /* border: 1px solid #28282e; */
        border-radius: 0;
        padding: 18px 14px 16px 14px !important;
        width: 216px;
        @media (max-width: 768px) {
            width: 132px;
            height: 48px;
            padding: 0 !important;
        }
    }

    .btn-cancel {
        color: #ffffff;
        font-family: "Open Sans", sans-serif;
        font-size: 14px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 22px;
        text-align: center;
        background-color: #000000;
        width: 216px;
        border-radius: 0;
        @media (max-width: 768px) {
            width: 132px;
            height: 48px;
        }
    }

    .modal-button {
        margin: 87px 0 0 0;
        border-top: 1px solid #d5d5d5;
    }
}
</style>
